export default "__VITE_ASSET__IWmEuBb7__"